import { Input, Form, Modal, Select } from 'antd';
import {
  closeModal,
  CreateOrganizationModalVisibleSelector,
} from './CreateOrganizationModalSlice';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import {
  createOrganization,
  CreateOrganizationModalDataSelector,
} from './CreateOrganizationModalSlice';
import * as S from './CreateOrganizationModal.styled';
import { IOrganization } from 'interfaces/main';
import { unwrapResult } from '@reduxjs/toolkit';
import { JSX } from 'react/jsx-runtime';

const { Option } = Select;
const { TextArea } = Input;

const CreateOrganizationModal = (): JSX.Element => {
  const dispatch = useAppDispatch();

  // Инициализация формы
  const [form] = Form.useForm();

  const data = useAppSelector(CreateOrganizationModalDataSelector);

  // Закрытие окна
  const onClose = () => {
    form.resetFields();
    dispatch(closeModal());
  };

  // Отправка формы
  const onSubmit = (organization: IOrganization) => {
    dispatch(
      createOrganization({
        ...organization,
      }),
    )
      .then(unwrapResult)
      .then((org: IOrganization) => {
        if (org.id) {
          form.resetFields();
        }
      });
  };

  // Видимость модального окна
  const isVisible = useAppSelector(CreateOrganizationModalVisibleSelector);

  return (
    <Modal
      open={isVisible}
      title="Create new organization"
      okText="Create"
      cancelText="Cancel"
      onCancel={onClose}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSubmit(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}>
      <Form form={form} layout="vertical" name="groupForm" initialValues={data}>
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: 'Please input title' }]}>
          <Input type="text" name="title" placeholder="Dubai Properties" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <TextArea
            style={{ width: '100%' }}
            rows={3}
            placeholder="Dubai Properties is also committed to sustainability, exemplified by The Sustainable City, a development focused on minimizing ecological impact through renewable energy, green spaces, and sustainable living practices."
            maxLength={1000}
            name="description"
          />
        </Form.Item>
        <S.Line>
          <Form.Item
            name="phone"
            style={{ width: '50%' }}
            label="Phone"
            rules={[{ required: true, message: 'Please input phone' }]}>
            <Input type="text" placeholder="+971 4 3381551" name="phone" />
          </Form.Item>
          <Form.Item name="whatsapp" style={{ width: '50%' }} label="WhatsApp">
            <Input type="text" placeholder="+971 4 3381551" name="whatsapp" />
          </Form.Item>
        </S.Line>
        <S.Line>
          <Form.Item name="email" style={{ width: '50%' }} label="Email">
            <Input
              type="text"
              placeholder="info@maksimzaycev.ru"
              name="email"
            />
          </Form.Item>
          <Form.Item
            name="site"
            style={{ width: '50%' }}
            label="Web site"
            rules={[{ required: true, message: 'Please input phone' }]}>
            <Input type="text" placeholder="www.maksimzaycev.ru" name="site" />
          </Form.Item>
        </S.Line>
        <S.Line>
          <Form.Item name="telegram" style={{ width: '50%' }} label="Telegram">
            <Input type="text" placeholder="@frontend_maks" name="telegram" />
          </Form.Item>
          <Form.Item name="facebook" style={{ width: '50%' }} label="Facebook">
            <Input type="text" placeholder="maksim.zaycev" name="facebook" />
          </Form.Item>
        </S.Line>
        <S.Line>
          <Form.Item name="needBorder" style={{ flex: 1 }} label="Need border">
            <Select style={{ width: '100%' }} placeholder="Please select">
              <Option value={true}>yes</Option>
              <Option value={false}>no</Option>
            </Select>
          </Form.Item>
        </S.Line>
      </Form>
    </Modal>
  );
};

export default CreateOrganizationModal;
